export default __webpack_public_path__ + "static/media/KFBbup3fQAXhheJwfMIyeQCjS2U2.3ee6e832.jpg";